<template>
  <div>
    <v-layout
      row
      wrap
      justify-center
      align-stretch
      class="mt-4"
      v-for="categoryTier in categoryTiers"
      :key="categoryTier.category"
    >
      <v-flex xs12>
        <h1 class="mt-4 mb-4 text-xs-center">{{ categoryTier.category }}</h1>
      </v-flex>
      <v-flex xs12 sm9 md4 v-for="tier in categoryTier.tiers" :key="tier.title" class="mb-4 tier-flex">
        <v-card class="mx-3 full-height">
          <v-layout column justify-space-between class="full-height">
            <div class="border-top" :class="tier.borderClass">
              <v-layout row justify-center>
                <v-card-title class="mt-2 mb-2">
                  {{ tier.title }}
                </v-card-title>
              </v-layout>
              <v-layout
                column
                justify-center
                class="tagline-section grey lighten-4 py-4"
              >
                <v-icon medium>{{
                  tier.taglineIcon
                }}</v-icon>
                <v-flex class="px-4 mt-3 text-xs-center">
                  {{ tier.subtext }}
                </v-flex>
              </v-layout>
              <v-card-text class="mt-4">
                <div v-if="tier.title === 'Core'" class="font-weight-bold">
                  Features include:
                </div>
                <div v-else class="font-weight-bold">
                  Everything from {{ tier.previousTierTitle }}, plus:
                </div>
                <ul class="mt-2">
                  <li
                    v-for="feature in tier.features"
                    :key="feature"
                    v-html="feature"
                  />
                </ul>
              </v-card-text>
            </div>
            <v-btn
              outline
              class="get-started my-4 mx-3 text-none"
              :href="tier.callToActionLink"
              @click="tier.callToActionMethod()"
              >{{ tier.callToAction }}</v-btn
            >
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script lang="ts">
export default {
  data() {
    return {
      categoryTiers: [
        {
          category: "Clinical",
          tiers: [
            {
              title: "Core",
              borderClass: "border-top-orange",
              subtext:
                "Foundational tools for high-impact research and pilot studies.",
              taglineIcon: "hub",
              features: [
                "Up to 1000 samples per-year",
                "Any type of analysis (metagenomics, 16S, isolates, etc.)",
                "24/7 support",
                "1 year data retention",
                "2 hour turnaround time",
                "Up to 3 users",
              ],
              callToAction: "Get in Touch",
              callToActionLink: "/quote",
            },
            {
              title: "Advanced",
              previousTierTitle: "Core",
              borderClass: "border-top-blue",
              subtext: "Routine volume, collaboration and compliance you can trust.",
              taglineIcon: "auto_graph",
              pricingLink: "/quote",
              features: [
                "Up to 3000 samples per-year",
                "6 year data retention",
                "SSO support",
                "Pipeline versioning and validation tooling",
                "Unlimited users",
              ],
              callToAction: "Get in Touch",
              callToActionLink: "/quote",
            },
            {
              title: "Premier",
              previousTierTitle: "Advanced",
              borderClass: "border-top-green",
              subtext: "The gold standard for regulated molecular diagnostics and IVD.",
              taglineIcon: "health_and_safety",
              pricingLink: "/quote",
              features: [
                "Up to 7000 samples per-year",
                "API integration support",
              ],
              callToAction: "Get in Touch",
              callToActionLink: "/quote",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.full-height {
  height: 100%;
}

.tier-flex {
  max-width: 500px;
}

.tagline-section {
  display: flex;
  align-items: center;
}

.border-top {
  border-top: 6px solid;
}

.border-top-orange {
  border-color: #f57c00; /* orange darken-2 */
}

.border-top-blue {
  border-color: #1976d2; /* blue darken-2 */
}

.border-top-green {
  border-color: #388e3c; /* green darken-2 */
}
</style>
